<template lang="pug">
  .editable-title
    .title(v-if="!editing") {{ value }}
    i.material-icons.edit-btn(v-if="!editing" @click="editing = true") edit
    input(ref="input" v-if="editing" :value="value")
    i.material-icons.save-btn(v-if="editing" @click="save") save
    i.material-icons.cancel-btn(v-if="editing" @click="editing = false") close
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      editing: false,
    }
  },
  methods: {
    save() {
      const newValue = this.$refs.input.value;
      this.$emit('input', newValue);
      this.editing = false;
    },
  },
}
</script>

<style lang="scss" scoped>
  .editable-title {
    margin: 2em 0 1em 0;
    .title, i {
      padding-bottom: 3px;
    }
    .title, input {
      font-size: 1.5em;
      font-weight: bold;
      color: var(--primary);
    }
    input {
      border: none;
      outline: none;
      border-bottom: 1px solid #BABABA;
    }
    display: flex;
    align-items: center;
    i {
      cursor: pointer;
      margin-left: .5em;
    }
  }
</style>